<div class="about py-5" id="about">
  <div class="container d-flex flex-column align-items-center gap-4">
    <div class="row w-100 gap-4">
      <div class="col-12 d-flex flex-column align-items-center gap-2">
        <h2 class="text-light fw-bold">About Me</h2>
        <div class="underline"></div>
      </div>
      <div class="col-12">
        <p class="text-center about-subtitle">
          Discover my background, skills, and the journey that shaped me as a
          developer.
        </p>
      </div>
    </div>

    <div class="row w-100 justify-content-between">
      <div class="col-md-6 text-light">
        <h5 class="mb-4 section-title">About Me</h5>
        <p class="text-tertiary">
          I'm a frontend developer with 4 years of professional experience
          crafting interactive, high-performance applications. From real-time
          collaboration tools to blockchain-integrated games and trading
          platforms, I specialize in creating seamless user experiences using
          Angular, PixiJS, and more.
        </p>
        <p class="text-tertiary">
          I'm open to Job opportunities where I can contribute, learn and grow.
          If you have a good opportunity that matches my skills and experience
          then don't hesitate to contact me.
        </p>
      </div>
      <div class="col-md-6 text-light d-flex flex-column gap-4">
        <h5 class="section-title m-0">My Experience</h5>
        @for (experience of experiences; track $index) {
        <div class="experience d-flex gap-3">
          <img
            [src]="experience.icon"
            class="experience-icon"
            alt="experience-icon"
            srcset=""
          />
          <div class="experience-info d-flex flex-column">
            <span class="designation">{{ experience.designation }}</span>
            <span class="company-info mb-2"
              >{{ experience.companyName }} | {{ experience.startDate }} -
              {{ experience.endDate }}</span
            >
            <span class="experience-desc">{{ experience.desc }}</span>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
